<div
  class="statistics-details relative pointer-events-auto z-10 col-start-1 row-start-1 items-center justify-center overflow-auto grid grid-flow-row"
>
  <div class="flex flex-col items-center w-full row-span-4">
    <img class="max-w-[400px] pointer-events-none" src="/assets/dashboard-preview.svg" />
    <h1 class="text-[24px] text-center font-bold max-w-[600px]">
      {{ 'notification-dashboard.empty-state.title' | translate: { count: 0 } }}
    </h1>
    <p class="text-[16px] opacity-70 text-center max-w-[450px] mt-2">
      {{ 'notification-dashboard.empty-state.desc' | translate }}
    </p>
  </div>
  <div class="flex flex-col items-center w-full row-span-1">
    <h1 class="text-[24px] text-center font-bold max-w-[600px]">
      {{ 'notification-dashboard.empty-state.tutorial.title' | translate: { count: 0 } }}
    </h1>
    <div class="flex w-full gap-6 flex-row px-12 mb-2 mt-5">
      @for (item of [1, 2]; track item) {
        <a
          [href]="
            'notification-dashboard.empty-state.tutorial.card' + item + '.url' | translate
          "
          target="_blank"
          class="flex-1 tutorial-card"
          (click)="clickEvent('LinkNotificationTutorial' + item)"
        >
          <div class="tutorial-title">
            {{
              'notification-dashboard.empty-state.tutorial.card' + item + '.title'
                | translate
            }}
          </div>
          <div class="tutorial-desc line-clamp-3">
            {{
              'notification-dashboard.empty-state.tutorial.card' + item + '.desc'
                | translate
            }}
          </div>
          <div class="font-bold tutorial-desc">
            {{ 'notification-dashboard.empty-state.tutorial.learn-more' | translate }}
          </div>
        </a>
      }
    </div>
  </div>
</div>
